module.exports = __webpack_public_path__ + "img/profile_position_pro.d4ecb69a.svg";